import screenfull from 'screenfull'
import {ActionContext} from 'vuex';

export default {
  namespaced: true,
  state: {
    // 全屏激活
    active: false
  },
  actions: {
    /**
     * @description 初始化监听
     */
    listen ({ commit }: ActionContext<any, any>) {
      return new Promise(resolve => {
        // @ts-ignore
        if (screenfull.enabled) {
          // @ts-ignore
          screenfull.on('change', () => {
            console.log('1')
            // @ts-ignore
            if (!screenfull.isFullscreen) {
              commit('set', false)
            }
          })
        }
        // end
        resolve()
      })
    },
    /**
     * @description 切换全屏
     */
    toggle ({ commit }: ActionContext<any, any>) {
      return new Promise(resolve => {
        // @ts-ignore
        if (screenfull.isFullscreen) {
          // @ts-ignore
          screenfull.exit()
          commit('set', false)
        } else {
          // @ts-ignore
          screenfull.request()
          commit('set', true)
        }
        // end
        resolve()
      })
    }
  },
  mutations: {
    /**
     * @description 设置 store 里的全屏状态
     * @param {Object} state vuex state
     * @param {Boolean} active active
     */
    set (state: any, active: any) {
      state.active = active
    }
  }
}
